import BlazinByStore from './BlazinByStore';
export default BlazinByStore;